// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.checkboxes {*/
/*    padding-left: 35px;*/
/*}*/

/*.checkboxes label {*/
/*    margin-bottom: 6px;*/
/*}*/

/*.group:not(:last-child) {*/
/*    margin-bottom: 20px;*/
/*}*/

.styles_grid__vz5X- {
    display: grid;
    /*grid-template-columns: 20px 1fr;*/
}
`, "",{"version":3,"sources":["webpack://./src/components/AsideMenuSelection/components/AdditionalChecks/styles.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,0BAA0B;AAC1B,IAAI;;AAEJ,sBAAsB;AACtB,0BAA0B;AAC1B,IAAI;;AAEJ,4BAA4B;AAC5B,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,aAAa;IACb,mCAAmC;AACvC","sourcesContent":["/*.checkboxes {*/\n/*    padding-left: 35px;*/\n/*}*/\n\n/*.checkboxes label {*/\n/*    margin-bottom: 6px;*/\n/*}*/\n\n/*.group:not(:last-child) {*/\n/*    margin-bottom: 20px;*/\n/*}*/\n\n.grid {\n    display: grid;\n    /*grid-template-columns: 20px 1fr;*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `styles_grid__vz5X-`
};
export default ___CSS_LOADER_EXPORT___;
